import renderInputField from 'components/FormControls/textInput'
import { Button, Typography } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { Field, Form, reduxForm } from 'redux-form'
import validator from 'utils/asyncValidator'
import shouldAsyncValidate from 'utils/shouldAsyncValidate'
import * as Yup from 'yup'
import formStyles from 'modules/Forms/common-form.module.scss'
import styles from 'modules/User/Security/Security.module.scss'
import QrCode from 'modules/User/Security/2fa/QrCode'
import { ROUTES } from 'constants/routes'
import { Link } from 'react-router-dom'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { useHistory } from 'react-router'
import { onlyNumbers } from 'utils/normalize/onlyNumbers'
import { ENABLE_2FA, GET_2FA } from 'modules/User/Security/2fa/types'

const validationSchema = Yup.object().shape({
  password: Yup.string().required('common::validation_messages.required'),
  code: Yup.string().required('common::validation_messages.required'),
})

let Enable2FA = ({ handleSubmit, submitting, form }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const pathGen = useGeneratePathI18n()
  const history = useHistory()

  const submit = useCallback(
    (values) =>
      new Promise((resolve, reject) => {
        dispatch({
          //TODO пробросим промис колбэки в сагу
          meta: { resolve, reject },
          type: ENABLE_2FA,
          payload: { data: values, formName: form },
        })
      }).then(() => {
        history.push(pathGen(ROUTES.USER_SECURITY_2FA))
        dispatch({ type: GET_2FA })
      }),
    [dispatch, form],
  )

  return (
    <>
      <Typography variant={'h1'} className={styles['security__heading']}>
        {t('user::security.2fa.enable_form.heading')}
      </Typography>
      <Typography weight={'medium'} variant={'p4'} className={styles['security__sub-heading']}>
        {t('user::security.2fa.enable_form.steps.one')}
      </Typography>
      <Form onSubmit={handleSubmit(submit)} noValidate>
        <div className={'margin-bottom-40'}>
          <Field
            fullWidth
            name="password"
            type={'password'}
            component={renderInputField}
            t={t}
            autoComplete="off"
            label={t('user::security.2fa.enable_form.password.placeholder')}
            placeholder={t('user::security.2fa.enable_form.password.placeholder')}
            cleanButton
            revealButton
          />
        </div>

        <QrCode />

        <Typography weight={'medium'} variant={'p4'} className={'margin-bottom-16'}>
          {t('user::security.2fa.enable_form.steps.four')}
        </Typography>

        <Typography
          variant={'p7'}
          noMargin
          className={'margin-bottom-16'}
          color={'Label-Secondary'}
        >
          {t('user::security.2fa.description_3')}
        </Typography>

        <Typography
          variant={'p7'}
          noMargin
          className={'margin-bottom-16'}
          color={'Label-Secondary'}
        >
          {t('user::security.2fa.description_4')}
        </Typography>

        <div className={'margin-bottom-40'}>
          <Field
            fullWidth
            name="code"
            type="text"
            inputMode="numeric"
            component={renderInputField}
            normalize={onlyNumbers}
            maxLength={6}
            autoComplete="off"
            t={t}
            placeholder={t('user::security.2fa.enable_form.code.placeholder')}
            cleanButton
          />
        </div>

        <div className={formStyles['formControl__action-buttons']}>
          <Button
            disabled={submitting}
            component={Link}
            to={pathGen(ROUTES.USER_SECURITY_2FA)}
            variant={'ghost'}
            grey
            size="l"
            type="button"
            color={'Label-Fifth'}
          >
            {t('common::form_buttons.cancel')}
          </Button>

          <Button
            disabled={submitting}
            size="l"
            variant="primary"
            type="submit"
            bgColor="Label-GU-Primary"
          >
            {t('user::security.2fa.enable_form.submit')}
          </Button>
        </div>
      </Form>
    </>
  )
}

Enable2FA = reduxForm({
  form: 'Enable2FA',
  updateUnregisteredFields: true,
  enableReinitialize: true,
  initialValues: {
    password: '',
    code: '',
  },
  shouldAsyncValidate: shouldAsyncValidate,
  asyncValidate: validator(validationSchema),
})(Enable2FA)

Enable2FA.propTypes = {
  handleSubmit: PropTypes.func,
  submitting: PropTypes.bool,
  form: PropTypes.string,
  onCancel: PropTypes.func,
}

Enable2FA.defaultValues = {
  handleSubmit: () => {},
  submitting: false,
  form: 'Enable2FA',
  onCancel: () => {},
}

export default Enable2FA
